module.exports = __webpack_public_path__ + "static/media/instagram-video.2d93770d.png";